import { useRef as t, useEffect as f } from "react";
function i(u, n) {
  const r = t();
  f(function() {
    return n != null && u.instance.on(n), r.current = n, function() {
      r.current != null && u.instance.off(r.current), r.current = null;
    };
  }, [
    u,
    n
  ]);
}
export {
  i as useEventHandlers
};
